export const BottomBar = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="fixed bottom-0 left-safe right-safe bg-white border-t p-4 mx-auto z-50 pb-safe">
      <div className="max-w-md mx-auto">
        <div className="flex items-center justify-between w-full">
          {children}
        </div>
      </div>
    </div>
  );
};
